import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { uploadMultiple, uploadSingle } from "appState/api/upload/upload";

export const singleUpload = createAsyncThunk(
  "upload/singleUpload",
  uploadSingle
);
export const multiUpload = createAsyncThunk(
  "upload/multiUpload",
  uploadMultiple
);

const initialState = {
  isLoading: false,
};

export const uploadSlice = createSlice({
  name: "upload",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(singleUpload.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(singleUpload.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(singleUpload.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(multiUpload.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(multiUpload.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(multiUpload.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default uploadSlice.reducer;
